import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import NoShowPolicyNotice from '../../NoShowPolicyNotice/NoShowPolicyNotice';

import css from './SubmitFinePrint.module.css';

/**
 * A component that displays the fine print for the submit button.
 * Note: this is not in use for ProductOrderForm.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.payoutDetailsWarning] - The payout details warning
 * @param {boolean} [props.isOwnListing] - Whether the listing is owned by the current user
 */
const SubmitFinePrint = ({
  payoutDetailsWarning,
  isOwnListing,
  omitYouWontBeChargedMessage = false,
  startNow = false,
  hideNoShowPolicy = false,
}) => {
  return (
    <div className={css.finePrint}>
      {payoutDetailsWarning ? (
        payoutDetailsWarning
      ) : isOwnListing ? (
        <FormattedMessage id="OrderPanel.ownListing" />
      ) : !omitYouWontBeChargedMessage ? (
        <FormattedMessage id="OrderPanel.youWontBeChargedInfo" />
      ) : null}
      {isOwnListing || hideNoShowPolicy ? null : (
        <NoShowPolicyNotice startNow={startNow} role="talker" />
      )}
    </div>
  );
};

export default SubmitFinePrint;
